var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopilotsBoxIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_303_168",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_303_168",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEi0lEQVR4nO2cXYhVVRTHf9OMzjgo0Uw6CgpiMIWWlYVPKiiooVgRUW/hU0r0HeEIaiVCOg+CIMyIiCaEH6Ao01CYFeFXOGoK9dCDkQP5FVIxjWOMzo4DOxjk7H3uvefuj3v2/sF6O/uutf5zZ5+11977QiQSiUQikYivCOBv4FegDzgIbABeAia5Dq5oQqvsHnAO2AS0uw60yEKPthHge+Bl4AHXQRdZ6NF2EXjedeAhCC2k9QLTXCcQgtAC+At4xXUSIQgtpO0AGlwnE4LQQpaGY1wnFILQAjgCjHWdVAhCC+AAUOc6sRCEFsA614mFIvQIsMR1ciEILYDfgVbXCYYgtAA+d51gKEILYL7rJEMRui9WIXaEFsAKAseW0D8QOMKizSVgbAq9nYCxKfQtoJFAEZbtOQLFttBbCRTbQv9EoNgWegRoIUCEA1tIgLgQ+n0CxIXQ3YZzmiqPQvwLXAHeIFChvzCYT7KFdsHHXXoXQl8ymM/jGr89QDMBCX3P4JGymRm+e10diRCObACYbSin0xm+97rojwuH9hvQZiCnSYp5erR9REBCC+CUoUbTePnS1U1fiwhIaCH/lU0wRs7JKr/9NlepwhPrMJTfOOCExm8XlnAtsBj1r/yioRyTOfuawu9d4AksIDyyAeApQ3kuln/MNL/HsIDwzPqByYZy7dL4fRbDCA/tDNCkiTm5rLQRuCmv7u0DHish14nAnwqfn2EY4al1amL+IOX5YeAToD4j3w6Fvzum71UKT+26JuYfNeO+kpWGioeAfxRjV2MQ4and0MR8PmPssYxOnWquTmpuY4ganDrezDl+vmLMbZPdPeFhibcl4xuZNIQ+BAY1n5OUcs8oxtfLMyZp44wty4UHNgQcBl4t8xs1A/hW87nHNWP3K8a8iyFciXsXOAm8DjyYI/6xck5W+VGVfWsUz++iYEI/XMUcWuQN3jQ/6xVjlimeT3rZhRK62nyqKffSaFc8/wuGKIrQTyr8JLvgabRVUL/noihCj9OUbGk0alaIRiiK0M0KP0kJmEaTpgIyQtGnjn7F83HqqJDNZb4MH1U8H1+GGlplu7Sc8m654vlY3mkWLMcrWLCsVTy/E0PU8hz9CPCdxsfXFSzB38EQtSh0HfC2LN10TaU5ivENmqaSsbPbwtGp/zysLMFH8nJUsSCUNukfOWPWdez+rzR0bdYdmtOmFEnoQzlj/kbz2b0lbGWp+tirKJjQc3PG/Jpic3ZDjs3ZIblLbgzbIndWKe63gMvypbZPLkCymKhpp+7BMLYEHvTgB626NfGptr2qhmmBfwY+BqbglqWy2ilnmV5VTIo7Cz9o0xxyHLYVZ7XEvQxsA+bhF81yb9L5T1vkEfeaZ9/ctD7Il5r4r8hyzwqVCDwiBXZ2lawEJmTsjg/b/u+rROj38Ju2Ei4LWa+AKjlS6zPJkd6zGTnsroXrby/gN7Mz4u9xdVW5XKFb8JunNbEfzeiDeCV0HX5TL3/l5v64u0vog3gldC0wXVYcSWVxVfZFnFNEob0kCm2JKHQkEolEIpEIvvIfGaO1NY8y99wAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotsBoxIcon2);
export default __webpack_public_path__ + "static/media/CopilotsBoxIcon2.c44f83ed5494356362aaebef1c9d92ce.svg";
export { ForwardRef as ReactComponent };